export const lang = {
    header:{
        Price:'Price',
        Wallet:'Wallet',
        Company:'Company',
        About:'About us',
        Team:'Team',
        Blog:'Blog',
        Career:'Career',
        Support:'Support',
        Contact:'Contact us',
        helpdesk:'Help Desk',
        faq:'FAQ',
        Transaction:'Transaction',
        Dashboard:'Dashboard',
        Donwload:'Donwload App',
        Login:'Sign in'
    },
    index:{
        title01:'Buy and sell cryptocurrency',
        tip01:'Fast and secure way to purchase or exchange 150+ cryptocurrencies',
        placeholder01:'Subscribe Now',
        send:'Send',
        get:'Get',
        ExchangeNow:'Exchange Now',
        title02:"The World's Leading Cryptocurrency Exchange",
        tip02:'Trade Bitcoin, ETH, and hundreds of other cryptocurrencies in minutes.',
        name:'Name',
        pirce:'Pirce',
        change:'Change',
        chart:'Chart',
        trade:'Trade',
        buy:'Buy',
        title03:"24-hour statistics",
        tip03:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere odit fuga nesciunt similique rerum nulla asperiores ullam deserunt architecto inventore.',
        newUser:'New user',
        regularUser:'Regular user',
        transactionsMade:'Transactions made',
        todayPair:"Today's champion pair",
        visitsToday:'Visits today',
        averageProcessingTime:'Average processing time',
        minutes:'minutes',
        title04:'So, What brings new product today?',
        title04_1:'Integrate our API',
        title04_2:'Join our Affiliate Program',
        tip04_1:'A white-label solution for your project, whether it is a wallet, a marketplace or a service provider. Set it up to accept any of 140+ cryptocurrencies listed on NowPay and get revenue for each transaction made.',
        tip04_2:'Place an affiliate link or customizable widget on your website, blog or social media profile. Get 50% of our revenue from every transaction made via either of the tools used.',
        learn:'Learn more',
        become:'Become an affiliate',
        easy:'EASY',
        easy_des:'Create an account, choose your crypto, input your receiving address, and send your funds',
        safe:'SAFE',
        safe_des:'As a non-custodial exchange, we don’t hold your deposits, so your funds are never vulnerable to hacks.',
        competitive:'COMPETITIVE',
        competitive_des:'Our exchange rates are updated in real time. What you see is what you get--with no additional fees.',
        mobileApp:'Mobile app',
        donwload_tip01:'Get the best mobile app to exchange or buy crypto on the go:',
        donwload_tip02:'Best rates on the market',
        donwload_tip03:'High limits',
        donwload_tip04:'No verification for exchange transactions',
        donwload_tip05:'More than 150 cryptocurrencies',
        donwload_tip06:'Buy bitcoin | buy crypto with USD, EUR or GBP',
        title05:'Let us hear from you directly!',
        address:'Address',
        addressValue:'SERVICES SWAPSPACE INC. \n MSB registration number:  M21739712  \n Main office :  56 HIGH PARK AVE UNIT 406 TORONTO, ON, CANADA M6P2R9',
        fullName:'Full name',
        email:'Email',
        placeholder02:'Full name',
        placeholder03:'hello@nowpay.com',
        placeholder04:'Tell us what we can help you with!',
        sendMessage:'Send message',
    },
    footer:{
        company:'Company',
        about:'About',
        career:'Career',
        affiliate:'Affiliate',
        ourPartner:'Our Partner',
        support:'Support',
        ticket:'Ticket',
        faq:'FAQ',
        blog:'Blog',
        helpdesk:'Helpdesk',
        exchangePair:'Exchange Pair',
        to:'to',
        socialContact:'Social contact',
    },
    price:{
        search:'Search',
        searchCoin:'Search Coin',
        list:'List',
        grid:'Grid',
        title:'Start creating an account in a few minutes, connect your bank account to start trading',
        tip:'Support multiple popular digital currencies',
        registerNow:'Register now',
        showMore:'Show More',
    },
    wallet:{
        title01:'All your digital assets in one place',
        tip01:'Take full control of your tokens and collectibles by storing them on your own device.',
        title02:'Multi-Coin Support',
        tip02:'Manage BTC, BCH, ETH, ETC, LTC, and all your ERC-20 tokens.',
        title03:'Digital collectibles',
        tip03:'Cats, monsters, art - store all your ERC721 collectibles in a single beautiful gallery.',
        title04:'Secure storage',
        tip04:'Your keys are protected with Secure Enclave and biometric authentication technology.',
        title05:'Easily send and receive crypto',
        tip05:'Pay anyone in the world with just their NowPay Wallet username',
    },
    team:{
        title01:'Want to work with us?',
        tip01:"We're always looking to hire talented folks to join our ever-growing team of designers, engineers, and support staff.",
        showDetails:"View Open Position",
        title02:'Small team. Big hearts.',
        tip02:'Our focus is always on finding the best people to work with. Our bar is high, but you look ready to take on the challenge.',
        title03:'Trusted by over Millions of business around the world'
    },
    career:{
        title01:'We saved a seat for you',
        title02:'Working at NowPay',
        tip02:'We’ve taken a huge challenge and made it into our mission: To create an open financial system for the world. To achieve this, we are building a team of smart, creative, passionate optimists, the kind of people who see opportunity where others see roadblocks. If this sounds like you, check out our open roles.',
        title03:'Our values',
        tip03:'Our values inform our behavior and the choices we make every day. As a result, our culture is a model of the world we’re trying to build: transparent, joyful, curious, and fast-moving. Our values are a large part of why NowPay is a great place to work, and why we’ve been successful. They are much more than words to us (and we have the emojis to prove it).',
        title04:'Our mission',
        tip04:'We think achieving our mission is the highest leverage way to bring about more economic freedom, innovation, efficiency, and equality of opportunity in the world. Each member of our team—every engineer, designer, kitchen team member, lawyer, writer, support coordinator, recruiter, and product manager—plays an important role in helping us achieve our mission.',
        title05:'Choose your team',
        occupation01:"Choose your team Business Development & Sales",
        occupation02:'Business Development Director',
        address02:'San Francisco, CA',
        occupation03:'Engineering - Frontend',
        occupation04:'Marketing & Communications'
    },
    helpdesk:{
        title:'How can we help you today?',
        search:'Search',
        title01:'Troubleshooting',
        title02:'My Transaction',
        list01:[
            'My transaction is stuck',
            'The amount is too low',
            'Sorry, payment was not received',
            "Still didn't get my refund",
        ],
        title03:'My Wallet',
        list02:[
            'My wallet address is recognized as invalid',
            'What does ‘Not yet redeemed mean?',
            'I sent my ABC coins to a non-ABC wallet',
            'ETH contract addresses'
        ],
        title04:'Other',
        list03:[
            "Customer service doesn't reply",
            "The amount is too low",
            "Can't log in",
            "Can’t enable / disable 2-FA"
        ],
        title05:"Can't find what you're looking for?",
        tip:'Let us help you!',
        submit:'Submit Ticket'
    },
    faq:{
        title01:'Frequently Asked Questions',
        tip01:'NowPay is an instant cryptocurrency exchange that allows you to exchange crypto fast and buy it with a bank card. The service provides the best crypto-to-crypto rates and supports over 140 cryptocurrencies available for exchange',
        title02:'How does NowPay work?',
        tip02:'NowPay’s trading algorithm is integrated into the largest cryptocurrency exchange platforms, including Binance, Poloniex, Bittrex, etc. In the span of milliseconds, NowPay makes bids and asks on the platforms, then selects and suggests the best available rate and displays the estimated rate on our site. The rates remain approximate until the transaction is actually made on the blockchain, which is why the exchange rate at the time of a transaction may differ slightly from the estimated rate that you see when you begin a transaction. To learn more about the process, see this article',
        title03:'Why should I trust you?',
        tip03:'NowPay is one of the most prominent instant cryptocurrency exchanges that has gained the trust of more than 2M users from all over the world. The service provides safe and fast transactions without revealing users identities. We provide the best possible rates by comparing a wide range of reliable trading platforms and work with a list of 140+ cryptocurrencies that is constantly increasing.',
        list01:[
            'No deposit storage.',
            'Instant exchange.',
            'Each account is protected with 2-factor authentication and an HTTPS protocol.',
            'More than 2 million satisfied users.'
        ],
        title04:'Does NowPay fix rates?',
        tip04_1:'NowPay mobile app does! Mobile app users will no longer be affected by the risks associated with crypto market fluctuations. Soon, the fixed-rate exchanges will also be implemented on the web version. To lock the current exchange rate, the user needs to click on the lock icon, which will result in them getting the exact same amount of crypto as is displayed on the screen. The rate is fixed for 15 minutes, which should be more than enough to carry out the exchange.',
        tip04_2:'Alternatively, NowPay offers our lowest fee of 0.25% for all crypto-to-crypto exchanges made at a floating rate.',
        title05:'Unenforceable provisions ',
        tip05:'If any provision of this website disclaimer is, or is found to be, unenforceable under applicable law, that will not affect the enforceability of the other provisions of this website disclaimer.',
        title06:'Links',
        tip06:'Responsibility for the content of external links (to web pages of third parties) lies solely with the operators of the linked pages.',
        title07:'Breaches of these terms and conditions',
        list02:[
            'NowPay reserves the rights under these terms and conditions to take action if you breach these terms and conditions in any way.',
            'Elaenia.com may take such action as seems appropriate to deal with the breach, including suspending your access to the website, suspending your earnings made trough Elaenia.com,prohibiting you from accessing the website, or bringing court proceedings against you.'
        ]
    },
    about:{
        title01:'About NowPay',
        tip01_1:'NowPay is built on open blockchain technology, making full use of the security and transparency they provide, integrating and converting the most widely integrated digital currency today.',
        tip01_2:'We will become the trustee and dragger of your digital asset conversion and eliminate the exchange regulatory risk. You can use familiar currency pricing goods and services to move currency between the exchange and NowPay at any time.',
        title02:'TsungHan Yang',
        tip02_1:'Head of NowPay',
        tip02_2:"TsungHan Yang has been working in the blockchain space.",
        title03:'Working at NowPay',
        tip03:'Digital currencies are changing the way we use and think about currencies. NowPay is the most trusted company in the industry, and we sincerely invite you to join our fast-growing team.',
        readMore:'Read more'
    },
    blog:{
        title01:'Why Litecoin needs MimbleWimble?',
        tip01:'The cracking goal of Cras chinwag Eaton bread is that I am talking about a pile of old tosh baked cakes.',
        title02:'When the market trend is in line with your plan, please stick to your trading plan!',
        tip02:'Since the price fell from 10500 to 9500 on the 6th to 3rd, the price has once again entered a long period of adjustment.',
        title03:'After violent deleveraging, Bitcoin prospered in the big crisis',
        tip03:'The economic activities in Europe and the United States have basically ceased due to the epidemic, and the stagnation in consumption, logistics and financial activities has led to financial advancement in various countries.',
        title04:'Bitcoin goes up and down eight times-long and short winners this week',
        tip04:'Since the price fell from 10500 to 9500 on the 6th to 3rd, the price has once again entered a long period of adjustment.',
        admin:'Admin',
        title05:'Recent Post',
        tip05_1:'Cryptocurrency and spx500 trend fantasy',
        tip05_2:'The BTC daily triangle arrangement has come to an end',
        tip05_3:'BTC will continue to rise, the trend will be difficult',
        title06:'Tags',
        tags:[ 'BTC','Dashboard','Financial','Exchange' ]
    },
    dashboard:{
        fav:'Fav',
        newPrice:'Price',
        tradingPair:'Trading pair',
        change:'Change',
        high:'High',
        low:'Low',
        volume:'Low',
        tape:'Tape',
        marketTrades:'Market Trades',
        amount:'Amount',
        limit:'Limit',
        market:'Market',
        buyPrice:'Price',
        buyAmount:'Amount',
        sellPrice:'Price',
        sellAmount:'Amount',
        total:'Total',
        buy:'Buy',
        sell:'Sell',
        price:'Price',
        time:'Time',
        executed:'Executed',
        unexecuted:'Unexecuted',
        action:'Action',
        noRecords:'No Records',
        openOrder:'Open Order',
        orderHistory:'Order History',
        type:'Type'
    }
}